import {ForwardGraph} from './types';
import {HashingStorage} from './hashing';
import {RefStorage} from './ref';
import {BaseForwardGraph} from './base';

export type {ForwardGraph, ForwardOp} from './types';

export function newForwardGraph(): ForwardGraph {
  return new BaseForwardGraph(new HashingStorage());
}

export function newRefForwardGraph(): ForwardGraph {
  return new BaseForwardGraph(new RefStorage());
}
